"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Order;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Order(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "order"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M77.709,50.158a2.5,2.5,0,0,1-2.5,2.5H38.471a2.5,2.5,0,1,1,0-5H75.209A2.5,2.5,0,0,1,77.709,50.158ZM90,28.763H38.472a2.5,2.5,0,0,0,0,5H90a2.5,2.5,0,1,0,0-5ZM27.334,42.117a2.5,2.5,0,1,0,3.535-3.535l-9.4-9.4a2.693,2.693,0,0,0-1.916-.794h-.009a2.678,2.678,0,0,0-1.907.794l-9.4,9.4a2.5,2.5,0,0,0,3.536,3.535l5.283-5.282v26.33l-5.283-5.282a2.5,2.5,0,1,0-3.536,3.535l9.392,9.392a2.69,2.69,0,0,0,1.918.8h.009a2.693,2.693,0,0,0,1.916-.794l9.4-9.4a2.5,2.5,0,1,0-3.535-3.535l-5.283,5.282V36.835ZM58.51,66.553H38.471a2.5,2.5,0,0,0,0,5H58.51a2.5,2.5,0,0,0,0-5Z"
  }))));
}